<template>
  <div>
    <el-dialog
        title="Điều khoản sử dụng"
        :before-close="handleClose"
        :visible.sync="isTermsOfUseDialog"
        :show-close="true"
        :close-on-click-modal="false"
        width="700px"
        top="20vh"
        @open="handleOpen"
    >
      <div style="line-height: 1.6; word-break: break-word; white-space: normal;">
        <p>
          Quý Khách hàng hiện đang sử dụng dịch vụ nhận thông báo biến động số dư tài khoản ngân hàng được tích hợp trong phần mềm
          <strong>OneKids</strong>, do đối tác trung gian của OneKids cung cấp.
        </p>
        <p>
          Căn cứ quy định tại <strong>Nghị định số 13/2023/NĐ-CP</strong> về bảo vệ dữ liệu cá nhân, nhằm đảm bảo việc tuân thủ quy định pháp luật liên quan đến bảo mật thông tin,
          <strong>OneKids</strong> xin xác nhận sự đồng thuận từ Quý Khách hàng đối với các nội dung sau trước khi sử dụng dịch vụ, cụ thể:
        </p>
        <ol style="padding-left: 20px;">
          <li>
            Tôi đồng ý cho phép <strong>OneKids</strong>, thông qua đối tác được ủy quyền, cung cấp và chia sẻ thông tin cần thiết với ngân hàng nơi tôi đang sử dụng tài khoản,
            nhằm mục đích đăng ký và kích hoạt dịch vụ nhận thông báo biến động số dư.
          </li>
          <li>
            Tôi đồng ý cho phép <strong>OneKids</strong> và đối tác trung gian tiếp nhận dữ liệu giao dịch phát sinh từ tài khoản ngân hàng của tôi,
            giới hạn trong phạm vi hiển thị thông tin trên phần mềm OneKids phục vụ mục đích quản lý thanh toán.
          </li>
          <li>
            Tôi xác nhận đã đọc, hiểu rõ và đồng ý để ngân hàng cung cấp thông tin liên quan đến trạng thái giao dịch của tài khoản cho đối tác trung gian và <strong>OneKids</strong>.
            Đồng thời, tôi chấp thuận với
            <a href="https://onekids.edu.vn/bdsd_dieu_khoan" target="_blank" style="color: #409EFF; text-decoration: underline;">
              toàn bộ điều kiện và điều khoản sử dụng dịch vụ
            </a>.
          </li>
        </ol>
        <p style="color: red; font-weight: 500;">
          * Bằng việc nhấn vào nút “Có, tôi đồng ý” bên dưới, Quý Khách hàng xác nhận đã hiểu rõ, đồng ý và chấp thuận toàn bộ nội dung nêu trên.
        </p>
      </div>


      <span slot="footer" class="dialog-footer">
    <el-button
        type="info"
        size="medium"
        @click="handleClose"
    >
      <i class="el-icon-circle-close" />
      <span>Không đồng ý</span>
    </el-button>
    <el-button
        type="primary"
        size="medium"
        :loading="loading.submit"
        @click="submitForm"
    >
      <i class="el-icon-circle-check" />
      <span>Có, tôi đồng ý</span>
    </el-button>
  </span>
    </el-dialog>
    <div>
      <OTPAuthenticationDialog
          :bank="bank"
          :response="response"
          :isOTPAuthenticationDialog="isOTPAuthenticationDialog"
          @closeDialog="handleClose"
      />
    </div>
  </div>
</template>

<script>


import OTPAuthenticationDialog from "@/views/sepay/dialog/OTPAuthenticationDialog.vue";
import sePayConnectionService from "@/services/SePayConnectionService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";

export default {
  name: "TermsOfUseDialog",
  components: {OTPAuthenticationDialog},
  props: {
    isTermsOfUseDialog: {
      type: Boolean,
      default: () => false,
    },
    bank: {
      type: Object,
      default: () => null
    },
  },

  data() {
    return {
      response: {},
      isOTPAuthenticationDialog: false,
      banks: [],
      loading: {
        submit: false,
      },
    }
  },

  methods: {
    handleClose() {
      this.isOTPAuthenticationDialog = false
      this.isOTPAuthenticationKienLongBankDialog = false
      this.isOTPAuthenticationOCBDialog = false
      this.$emit("closeDialog");
    },
    handleOpen(){

    },

    submitForm() {
      this.loading.submit = true;
       sePayConnectionService.connectionSePayBySchool(this.$props.bank).then((resp) => {
        if (resp.data.status === 200) {
          this.response = resp.data.data;
          if (this.$props.bank.brandName === "ACB" || this.$props.bank.brandName === "VietinBank"
              || this.$props.bank.brandName === "MBBank" || this.$props.bank.brandName === "KienLongBank") {
            this.isOTPAuthenticationDialog = true
          } else if (this.$props.bank.brandName === "OCB") {
            NotifyMessage.leftCornerNotificationSuccess("Tạo mới thành công!")
            this.handleClose()
          }
        }else {
          NotifyMessage.leftCornerNotificationError("Tạo mới thất bại!")
        }
        this.loading.submit = false;
      }).catch((err) => {
        console.log(err);
         this.loading.submit = false;
      })
    },
  }
}
</script>

<style lang="scss" scoped>

</style>